import React, { Component } from 'react'
import {Router} from '@reach/router';
import Nav from './Nav';
import '../styles/Main.css'
// import Router from '@reach/router';
import AboutUs from './AboutUs';
import Services from './Services';
import Gallery from './Gallery';
import Contacts from './Contacts';
import Home from './Home';
import Footer from './Footer';

export class Main extends Component {
    render() {
        return (
            <div className="Main">
                <Nav />
                <Router>
                    <Home path="/" />
                    <AboutUs path='/about' />
                    <Services path='/services' />
                    <Gallery path='/gallery' />
                    <Contacts path='/contacts' />
                </Router>
                <Footer />
            </div>
        )
    }
}

export default Main
